/** Tiles on one Video Wall page. The last page keeps only the cameras that remain. */
export const WALL_PAGE_SIZE = 16;

export function wallPage<T>(items: readonly T[], page: number, pageSize = WALL_PAGE_SIZE): T[] {
  if (pageSize < 1 || items.length === 0) return [];
  const pageCount = Math.max(1, Math.ceil(items.length / pageSize));
  const safe = Math.min(Math.max(0, page), pageCount - 1);
  return items.slice(safe * pageSize, safe * pageSize + pageSize);
}
